"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../constants");
var _colors = require("../../birch/colors");
var _excluded = ["enabled", "id", "value", "tiny"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var azaleaVersion = {
  offState: {
    backgroundColor: _constants.colors.mediumGrey,
    borderColor: _constants.colors.mediumGrey
  },
  onState: {
    backgroundColor: _constants.colors.mediumGreenhouseGreen,
    borderColor: _constants.colors.mediumGreenhouseGreen
  },
  toggleColor: _constants.colors.lightestGrey
};
var birchVersion = {
  offState: {
    backgroundColor: _colors.FullPalette.GREY_700,
    borderColor: _colors.FullPalette.GREY_700
  },
  onState: {
    backgroundColor: _colors.FullPalette.GREEN_700,
    borderColor: _colors.FullPalette.GREEN_700
  },
  toggleColor: _colors.FullPalette.WHITE
};
var versionSelector = (0, _constants.buildVersionSelector)(azaleaVersion, birchVersion);
var Toggle = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Toggle, _React$Component);
  var _super = _createSuper(Toggle);
  function Toggle() {
    var _this;
    (0, _classCallCheck2["default"])(this, Toggle);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.renderCheckmark = function () {
      return /*#__PURE__*/React.createElement("svg", {
        width: "15px",
        height: "14px",
        viewBox: "0 0 11 10",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("title", null, "Checkmark"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
        d: "M7.74102446,0.205040582 C8.04525578,-0.0843809683 8.51975872,-0.0650721456 8.80085644,0.248168045 C9.08195415,0.561408235 9.06320065,1.04996211 8.75896933,1.33938366 L3.47305862,7.79495982 C3.16967672,8.0835733 2.69675054,8.06529178 2.41524145,7.75406866 L0.20115767,5.24932692 C-0.0811395998,4.93723242 -0.064260592,4.44860609 0.238857989,4.15794947 C0.54197657,3.86729284 1.01654988,3.88467167 1.29884715,4.19676616 L3.00380162,6.13863863 L7.74102446,0.205040582 Z",
        id: "path-1"
      })), /*#__PURE__*/React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-833.000000, -351.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(829.000000, 345.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(1.000000, 3.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(4.000000, 4.000000)"
      }, /*#__PURE__*/React.createElement("mask", {
        fill: "white"
      }, /*#__PURE__*/React.createElement("use", {
        xlinkHref: "#path-1"
      })), /*#__PURE__*/React.createElement("use", {
        stroke: "#FFFFFF",
        strokeWidth: "0.749999448",
        fill: "#FFFFFF",
        fillRule: "nonzero",
        xlinkHref: "#path-1"
      })))))));
    };
    return _this;
  }
  (0, _createClass2["default"])(Toggle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        enabled = _this$props.enabled,
        id = _this$props.id,
        value = _this$props.value,
        tiny = _this$props.tiny,
        otherProps = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return (
        /*#__PURE__*/
        // @ts-expect-error - TS2769 - No overload matches this call.
        React.createElement(ToggleWrapper, (0, _extends2["default"])({
          enabled: enabled,
          tiny: tiny,
          "data-toggle": true
        }, otherProps), !tiny && /*#__PURE__*/React.createElement("span", {
          role: "switch",
          "aria-checked": enabled ? 'true' : 'false'
        }, /*#__PURE__*/React.createElement(ToggleChoice, {
          choice: "on",
          enabled: enabled
        }, this.renderCheckmark())), /*#__PURE__*/React.createElement(ToggleThumb, {
          enabled: enabled,
          tiny: tiny
        }), /*#__PURE__*/React.createElement(ToggleInput, {
          type: "checkbox",
          value: value,
          id: id,
          name: id,
          checked: enabled,
          readOnly: true
        }))
      );
    }
  }]);
  return Toggle;
}(React.Component);
Toggle.defaultProps = {
  clickable: true,
  value: 'on',
  tiny: false
};
var ToggleWrapper = _styledComponents["default"].div.withConfig({
  displayName: "toggle__ToggleWrapper"
})(["", " width:", ";", " height:", ";padding:0;border-radius:30px;background-color:", ";transition:all 0.2s ease;position:relative;user-select:none;", " ", " ", " &:hover{cursor:pointer;}"], /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.tiny ? '30px' : '50px';
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.tiny ? '16px' : '25px';
}, function (props) {
  var _props$theme, _props$theme2;
  return (
    // @ts-expect-error - TS2339 - Property 'enabled' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "key" | keyof HTMLAttributes<HTMLDivElement>> & { ...; }, DefaultTheme>'.
    props.enabled ? versionSelector((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.name).onState.backgroundColor : versionSelector((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.name).offState.backgroundColor
  );
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.clickable ? '' : 'pointer-events: none;';
}, function (props) {
  return (
    // @ts-expect-error - TS2339 - Property 'clickable' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "key" | keyof HTMLAttributes<HTMLDivElement>> & { ...; } & object, DefaultTheme>'.
    props.clickable ? '' : 'opacity: 0.3;'
  );
});
ToggleWrapper.displayName = 'ToggleWrapper';
var ToggleChoice = _styledComponents["default"].span.withConfig({
  displayName: "toggle__ToggleChoice"
})(["position:absolute;top:4px;bottom:0px;margin-top:auto;margin-bottom:auto;transition:opacity 0.25s ease;left:9px;", " ", ""], /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.enabled ? 'opacity: 1;' : 'opacity: 0;';
});
ToggleChoice.displayName = 'ToggleChoice';
var ToggleThumb = _styledComponents["default"].div.withConfig({
  displayName: "toggle__ToggleThumb"
})(["transition:all 0.5s cubic-bezier(0.23,1,0.32,1) 0ms;position:absolute;top:0;", " width:", ";", " height:", ";", " border:", " solid;border-radius:50%;background-color:", ";box-sizing:border-box;", ";"], /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.tiny ? '16px' : '25px';
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.tiny ? '16px' : '25px';
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.tiny ? '3px' : '4px';
}, function (props) {
  var _props$theme3;
  return versionSelector((_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.name).toggleColor;
}, function (props) {
  var _props$theme4, _props$theme5;
  return (
    // @ts-expect-error - TS2339 - Property 'enabled' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "key" | keyof HTMLAttributes<HTMLDivElement>> & { ...; } & object, DefaultTheme>'.
    props.enabled ? (0, _styledComponents.css)(["border-color:", ";", " left:", ";"], versionSelector((_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.name).onState.borderColor, /* @ts-expect-error Flow -> TS migration */'', props.tiny ? '14px' : '25px') : (0, _styledComponents.css)(["border-color:", ";left:0;"], versionSelector((_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : _props$theme5.name).offState.borderColor)
  );
});
ToggleThumb.displayName = 'ToggleThumb';
var ToggleInput = _styledComponents["default"].input.withConfig({
  displayName: "toggle__ToggleInput"
})(["border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;"]);
ToggleInput.displayName = 'ToggleInput';
var ThemedToggle = (0, _styledComponents.withTheme)(Toggle);
var _default = ThemedToggle;
exports["default"] = _default;